import { SHARES_PER_NODE } from 'hooks/useSafePOKT/useSafePOKT.constants'
import {
  DISABLED_INFO_BALANCE,
  DISABLED_INFO_DISCONNECTED,
  DISABLED_INFO_HOLDER_ACTIONS,
  DISABLED_INFO_MINDEMAND,
} from './buyCrypto.constants'

export const applyDiscountToUSDC = (
  usdc: number,
  shares: number,
  discount: number
) => {
  if (shares >= SHARES_PER_NODE / 2) {
    if (shares >= SHARES_PER_NODE) {
        return usdc * (1 - discount)
    }
      return usdc * (1 - discount / 2)
  }

    return usdc
}

          //setBuyInputValue(
           // 'USDC',
            //applyDiscountToUSDC(
            //  Number(shares) / exchangeRate,
            //  Number(shares),
            //  safePokt.nodeDiscount
           // ).toString()
          //)

export const applyDiscountToShares = (
  usdc: number,
  discount: number,
  sharePrice: number
) => {
  let halfNodePrice = (SHARES_PER_NODE / 2) * sharePrice
  halfNodePrice -= halfNodePrice * (discount / 2)

  let nodePrice = SHARES_PER_NODE * sharePrice
  nodePrice -= nodePrice * discount

  if (usdc >= nodePrice) {
    const newSharePrice = sharePrice - sharePrice * discount
    return usdc / newSharePrice
  } else if (usdc >= halfNodePrice) {
    const newSharePrice = sharePrice - sharePrice * (discount / 2)
    return usdc / newSharePrice
  }

  return usdc / sharePrice
}

         // setBuyInputValue(
         //   'SHARES',
         //   applyDiscountToShares(
         //     Number(usdc),
         //     safePokt.nodeDiscount,
         //     safePokt.poktBuyPrice * 10
         //   ).toString()
         // )

export const getDisabledInfo = (
  disconnected: boolean,
  actionsDisabled: boolean,
  hasEnoughBalance: boolean,
  minDemandAmount: boolean,
  minBuyAmount: number,
): string => {
  if (disconnected) {
    return DISABLED_INFO_DISCONNECTED
  }
  if (actionsDisabled) {
    return DISABLED_INFO_HOLDER_ACTIONS
  }
  if (!hasEnoughBalance) {
    return DISABLED_INFO_BALANCE
  }
  if (minDemandAmount) {
      return DISABLED_INFO_MINDEMAND + minBuyAmount.toString() + ' USDC'
  }

  return ''
}

export const getDisabledInfoEth = (
    disconnected: boolean,
    actionsDisabled: boolean,
    hasEnoughBalance: boolean,
): string => {
    if (disconnected) {
        return DISABLED_INFO_DISCONNECTED
    }
    if (actionsDisabled) {
        return DISABLED_INFO_HOLDER_ACTIONS
    }
    if (!hasEnoughBalance) {
        return DISABLED_INFO_BALANCE
    }
    return ''
}

export const DiscountConstants = (shares: number, buyDemandMinAmount: number,maxDiscountShares: number, nodeDiscount: number, exchangeRate: number ): number[] => {
    //console.log("shares: "+shares+"BuyDmMinAmount: "+buyDemandMinAmount+" Max Dc Shares: "+maxDiscountShares+" MAx dc: "+nodeDiscount+" Exch rate: "+exchangeRate)
    let newRate
    let discount
    if (shares > maxDiscountShares) {
        newRate = (buyDemandMinAmount * nodeDiscount) / (shares / exchangeRate)
        discount = buyDemandMinAmount * nodeDiscount
    } else {
        newRate = (shares / maxDiscountShares) * nodeDiscount
        discount = shares / exchangeRate * newRate
    }
    const discountPercentage = newRate * 100
    const sharePrice = (1 / exchangeRate) * (1 - (discountPercentage / 100))
    return [sharePrice, discount, discountPercentage]
}

export const USDCtoSHARESdiscount = (   usdc: number,
                                        buyDemandMinAmount: number,
                                        nodeDiscount: number,
                                        poktBuyPrice: number,
                                        poktPerShare: number
                                    ): number => {  //Return discount in Shares

    const exchangeRate = 1 / (poktBuyPrice * poktPerShare)
    let newRate = usdc / buyDemandMinAmount
    if (newRate > 1) newRate = 1
    newRate *= nodeDiscount
    const newexchangeRate =
        1 / ((poktBuyPrice * (1 - newRate)) * poktPerShare)
    let totalShares
    if (usdc > buyDemandMinAmount) {
        totalShares = buyDemandMinAmount * newexchangeRate
        totalShares += ((usdc - buyDemandMinAmount) * exchangeRate)
    } else totalShares = usdc * newexchangeRate

    return totalShares
}

export const SHAREStoUSDCdiscount = (   shares: number,
                                        maxDiscountShares: number,
                                        nodeDiscount: number,
                                        poktBuyPrice: number,
                                        poktPerShare: number
                                    ): number => {  //Returns discount in USDC

    const exchangeRate = 1 / (poktBuyPrice * poktPerShare)
    let newRate = shares / maxDiscountShares
    if (newRate > 1) newRate = 1
    newRate *= nodeDiscount
    const newexchangeRate =
        1 / ((poktBuyPrice * (1 - newRate)) * poktPerShare)
    let totalusdc
    if (Number(shares) > maxDiscountShares) {
        totalusdc = maxDiscountShares / newexchangeRate
        totalusdc += ((Number(shares) - maxDiscountShares) / exchangeRate)
    } else totalusdc = Number(shares) / newexchangeRate


    return totalusdc
}



export const USDCtoSHARESdiscount2 = (
    usdc: number,
    buyDemandMinAmount: number,
    maxDiscountShares: number,
    nodeDiscount: number,
    poktBuyPrice: number,
    poktPerShare: number
): number => {  //Return discount in Shares

    const newMaxUSDCDiscount = buyDemandMinAmount * (1 - nodeDiscount);
    let remainingShares = 0
    if (usdc > newMaxUSDCDiscount) {
        
        remainingShares = (usdc - newMaxUSDCDiscount) / (poktBuyPrice * poktPerShare)
        usdc = newMaxUSDCDiscount

    }
    const b = poktBuyPrice * poktPerShare
    const a = (b / maxDiscountShares * nodeDiscount * -1)
    const c = usdc * -1 //PF

    const d = b * b - 4 * a * c
    const eq = (-b + Math.sqrt(d) ) / (2*a)
    return (eq + remainingShares)
}
